<span
  tabindex="0"
  [attr.data-testid]="'burger-menu-icon'"
  (keydown.enter)="isMenuOpen.set(!isMenuOpen())"
  (click)="isMenuOpen.set(!isMenuOpen())"
  class="material-symbols-rounded cursor-pointer">
  menu
</span>
@if (isMenuOpen()) {
  <div
    class="absolute top-0 right-0 bottom-0 left-0 z-10 overflow-y-scroll bg-white px-4 py-5"
    [attr.data-testid]="'burger-menu'"
    [ngStyle]="{
      backgroundColor: isDarkMode()
        ? corporateDesignService.corporateDesign().colorAdmixtures
            .dark_background
        : '',
    }">
    <div
      class="flex flex-row justify-end px-4 py-6"
      [attr.data-testid]="'burger-menu-header'">
      <span
        tabindex="0"
        [attr.data-testid]="'burger-menu-close-icon'"
        (keydown.enter)="isMenuOpen.set(!isMenuOpen())"
        (click)="isMenuOpen.set(!isMenuOpen())"
        class="material-symbols-rounded cursor-pointer">
        close
      </span>
    </div>
    <ng-container *ngTemplateOutlet="menuContent()"></ng-container>
  </div>
}
